import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';
import { FormSpy } from 'react-final-form';

import { Form, IFormContentProps, Field, TextField } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { Button, ButtonTypes } from '@gem/ui-kit';

import { INewContactPresenterParams, useNewContactViewPresenter } from './NewContactView.presenter';
import styles from './NewContactView.styles.m.css';

type INewContactViewProps = INewContactPresenterParams;

export const NewContactView: FC<INewContactViewProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useNewContactViewPresenter(props);
  const isLoading = presenter.isLoading;

  return (
    <div className={styles.container}>
      <Form
        onSubmit={presenter.onSubmit}
        initialValues={presenter.initialValue}
        keepDirtyOnReinitialize={presenter.keepDirtyOnReinitialize}
      >
        {({ handleSubmit }: IFormContentProps): ReactElement => (
          <form
            className={styles.form}
            onSubmit={handleSubmit}
          >
            <div>
              <Field
                className={styles.userNameField}
                isNeedTrim
                name="contactNameSearch" // 'Search' word at the end of the name is trick for disabling safari autofill. Inspired by https://bytes.grubhub.com/disabling-safari-autofill-for-a-single-line-address-input-b83137b5b1c7
                label={t('profile_username_hint')}
                component={TextField}
                maxLength={50}
                setRef={presenter.userNameRef}
                validate={presenter.usernameValidate}
                successText={' '}
              />
              <Field
                name="contactPhone"
                label={t('new_contact_phone')}
                component={TextField}
                placeholder={presenter.placeholder}
                validate={presenter.validatePhone}
                parse={presenter.parsePhoneNumber}
                validatingText={' '}
                successText={' '}
              />
            </div>
            <div className={styles.footer}>
              <FormSpy
                subscription={{
                  pristine: true,
                  invalid: true,
                  validating: true,
                }}
              >
                {({ pristine, invalid, validating, form }): ReactElement => (
                  <Button
                    size="20"
                    type={ButtonTypes.Submit}
                    isLoading={isLoading}
                    isDisabled={
                      pristine || invalid || validating || presenter.isPristinePhoneField(form)
                    }
                    className={styles.createButton}
                    theme="primary"
                  >
                    {t('common_create')}
                  </Button>
                )}
              </FormSpy>
            </div>
          </form>
        )}
      </Form>
    </div>
  );
});
